import { Box } from '@tonic-one/react';
import React from 'react';
import ApprovedSenders from './ApprovedSenders';

const ApprovedLists = () => {
  return (
    <Box py="2x">
      <ApprovedSenders />
    </Box>
  );
};

export default React.memo(ApprovedLists);
